import React from "react";
import ButtonAtm from "../../../atoms/ButtonAtm";
import { Devices } from "../../../molecules/DeviceScreenMol";
import Button from "../../../quarks/Button";
import FlexContainerOrg from "../../FlexContainerOrg";
import PushOrg from "../../PushOrg";
import RelativeContainerOrg from "../../RelativeContainerOrg";
import { DesktopIcon, MobileIcon, StyledAbsoluteContainerOrg, StyledFlexContainerOrg, StyledPushOrg, TabletIcon } from "./HeaderMol.styled";
var BackArrow = function BackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m12 3 1.586 1.586-6.277 6.289H21v2.25H7.309l6.277 6.289L12 21l-9-9 9-9Z",
    fill: "#000"
  }));
};
BackArrow.defaultProps = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function HeaderMol(_ref) {
  var activeDevice = _ref.activeDevice,
    backButton = _ref.backButton,
    dekstopButtonOnClick = _ref.dekstopButtonOnClick,
    tabletButtonOnClick = _ref.tabletButtonOnClick,
    mobileButtonOnClick = _ref.mobileButtonOnClick;
  return /*#__PURE__*/React.createElement(RelativeContainerOrg, null, /*#__PURE__*/React.createElement(StyledFlexContainerOrg, {
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(StyledAbsoluteContainerOrg, {
    leftUnit: 0
  }, /*#__PURE__*/React.createElement(ButtonAtm, {
    color: "dark",
    size: "default",
    variant: "text",
    title: backButton.title,
    onClick: backButton.onClick
  }, /*#__PURE__*/React.createElement(FlexContainerOrg, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(BackArrow, null), /*#__PURE__*/React.createElement(StyledPushOrg, {
    leftSpace: 1
  }, backButton.title)))), /*#__PURE__*/React.createElement(FlexContainerOrg, null, /*#__PURE__*/React.createElement(PushOrg, {
    rightSpace: {
      small: 3,
      medium: 3,
      large: 4
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: dekstopButtonOnClick
  }, /*#__PURE__*/React.createElement(DesktopIcon, {
    $active: activeDevice === Devices.DESKTOP
  }))), /*#__PURE__*/React.createElement(PushOrg, {
    rightSpace: {
      small: 3,
      medium: 3,
      large: 4
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: tabletButtonOnClick
  }, /*#__PURE__*/React.createElement(TabletIcon, {
    $active: activeDevice === Devices.TABLET
  }))), /*#__PURE__*/React.createElement(Button, {
    onClick: mobileButtonOnClick
  }, /*#__PURE__*/React.createElement(MobileIcon, {
    $active: activeDevice === Devices.MOBILE
  })))));
}
export default HeaderMol;